import { render, staticRenderFns } from "./book-share-image.vue?vue&type=template&id=54f54bc4&scoped=true&"
import script from "./book-share-image.vue?vue&type=script&lang=js&"
export * from "./book-share-image.vue?vue&type=script&lang=js&"
import style0 from "./book-share-image.vue?vue&type=style&index=0&id=54f54bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f54bc4",
  null
  
)

export default component.exports